/**
 * discovery 发现页路由（已弃用旧 discovery/showUp）
 */
const inviteSP = () => import(/* webpackChunkName: "module-discovery" */ "@/views/discovery/inviteSP");
const ipRight = () => import(/* webpackChunkName: "module-discovery" */ "@/views/discovery/ipRight");

export default [
  {
    // 市调报告邀请分享
    path: "/discovery/inviteSP",
    name: "inviteSP",
    component: inviteSP,
  },
  {
    // 知识产权
    path: "/ipRight",
    name: "ipRight",
    component: ipRight,
    meta: { id: 10058 },
  },
];
